// extracted by mini-css-extract-plugin
module.exports = {"logoImg":"MangoLogo_logoImg__zskKy"};